import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useRestMutation from "@/remoteState/useRestMutation";

const useCreateTextSetContent = () => {
  const createTextSetContent = useCallback((payload) => {
    const requestParams = {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
    };

    return new Request(
      `${API_BASE_URL}/api/v3/content-membership/`,
      requestParams,
    );
  }, []);
  return useRestMutation(createTextSetContent);
};

export default useCreateTextSetContent;
